import { render, staticRenderFns } from "./JourneyStepsExpandTable.vue?vue&type=template&id=8bba4c9a&"
import script from "./JourneyStepsExpandTable.vue?vue&type=script&lang=ts&"
export * from "./JourneyStepsExpandTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports